export enum FileShareCategory {
  FILE = 'File',
  METADATA = 'Metadata',
  ALL = 'All',
}

export enum ShareModuleCategory {
  INTERNAL = 'Internal',
  SHARED_OUT = 'Shared Out',
  SHARED_IN = 'Shared In',
  ALL = 'All',
}

export enum FileSizeUnits {
  B = 'Bytes',
  KB = 'KB',
  MB = 'MB',
  GB = 'GB',
}

export enum MalwareScanOutcome {
  CLEAN = 'Clean',
  INFECTED = 'Infected',
  UNKNOWN = 'Unknown',
  UNSCANNABLE = 'Unscannable',
  ERROR = 'Error',
  INFECTED_ALLOWED = 'InfectedAllowed',
}

export enum ResultStatus {
  PASS = 'Pass',
  FAIL = 'Fail',
}

export enum FilesFilterOptions {
  RECORD_TYPE = 'Record Type',
  FILE_TYPE = 'File Type',
  RECORD_CATEGORY = 'Record Catgeory',
}

export enum FileCategory {
  DOCUMENT = 'Document',
  SPREADSHEET = 'Spreadsheet',
  PRESENTATION = 'Presentation',
  IMAGE = 'Image',
  AUDIO = 'Audio',
  VIDEO = 'Video',
  ARCHIVE = 'Archive',
  EMAIL = 'Email',
  APPLICATION = 'Application',
  FONT = 'Font',
  NOT_SHARED = 'NotShared',
}

export enum FileUploadStatus {
  PROCESSING = 'Processing',
  PENDING_REVIEW = 'Pending Review',
  COMPLETE = 'Complete',
  PRE_EXISTING = 'Pre-Existing',
  FAILED = 'Failed',
  PENDING = 'Pending',
}

export enum FilesIconMapper {
  Document = 'doc',
  Video = 'video',
  Presentation = 'ppt',
  Spreadsheet = 'excel',
  Image = 'image',
  Audio = 'audio',
  Archive = 'archive',
  Application = 'app',
  Font = 'font',
  Other = 'file',
  Email = 'email-file',
  NotShared = 'file-not-shared',
}
